import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DocumentCategoryDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-document-category',
  templateUrl: './document-category.component.html',
  styleUrls: ['./document-category.component.scss'],
})
export class DocumentCategoryComponent implements OnChanges {
  documentcategoryForm: FormGroup;
  documentcategoryFormArray: FormGroup;
  control = new FormControl();
  @Input() documentcategorys: DocumentCategoryDto[];
  @Input() routeAnimationsElements: any;
  @Output() documentcategory = new EventEmitter<DocumentCategoryDto[]>();
  @Output() deleteDocumentCategoryEvent = new EventEmitter<any>();

  selectedDocumentCategory: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createDocumentCategoryForm();
  }

  createDocumentCategoryForm() {
    this.documentcategoryForm = this.fb.group({
      DocumentCategoryName: ['', Validators.required],
      id: null,
    });
    this.documentcategoryFormArray = this.fb.group({
      DocumentCategorys: this.fb.array([]),
    });
    this.setDocumentCategory();
  }

  // method to display documentcategorys
  setDocumentCategory() {
    const control = this.documentcategoryFormArray.controls
      .DocumentCategorys as FormArray;
    this.documentcategorys.forEach((e) => {
      control.push(
        this.fb.group({
          DocumentCategoryName: e.DocumentCategoryName,
          id: e.id,
        })
      );
    });
  }

  // method to add DocumentCategory
  addDocumentCategory(value: DocumentCategoryDto) {
    const control = this.documentcategoryFormArray.controls
      .DocumentCategorys as FormArray;
    control.insert(
      0,
      this.fb.group({
        DocumentCategoryName: value.DocumentCategoryName,
        id: null,
      })
    );
  }

  selectDocumentCategory(value) {}

  // method to delete documentcategory from arrary list
  deleteDocumentCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.documentcategoryFormArray.controls
          .DocumentCategorys as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.documentcategorys.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.documentcategorys[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: DocumentCategoryDto) {
    if (this.documentcategoryForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.documentcategoryFormArray
        .get('DocumentCategorys')
        ['controls'][this.selectedIndex].patchValue({
          DocumentCategoryName: formValue.DocumentCategoryName,
        });
    } else {
      this.addDocumentCategory(formValue);
    }
    this.selectedIndex = null;
    this.documentcategoryForm.reset();
  }

  onEdit(index, value: DocumentCategoryDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.documentcategoryForm.patchValue({
      DocumentCategoryName: value.DocumentCategoryName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.documentcategoryForm.reset();
  }

  onSubmit(formValue: DocumentCategoryDto[]) {
    this.documentcategory.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteDocumentCategoryEvent.emit(this.filteredDelete);
    }
  }
}
